import { Component, Injector, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from 'projects/ProjetoBaseAngular/app/base-crud.component';
import { ConfigModel, TenantModel } from 'projects/ProjetoBaseAngular/domain/models';
import { TypesService } from 'projects/admin/src/domain/services';
import { ChatBotNodoModel } from '../domain/models';
import { ChatBotNodoModalComponent } from './chatbot-nodo-modal/chatbot-nodo-modal.component';
import { ChatBotNodoService } from '../domain/services/chatbot-nodo.service';
import Swal from 'sweetalert2';
import { WhatsChatService } from '../domain/services/whatschat.service';
import { ConfigChatbotConsts, WhatsAppApiEvents } from 'projects/admin/src/domain/consts';
import { ConfigService } from 'projects/ProjetoBaseAngular/domain/services';
import { MetaCredenciaisDto, MetaSubscribedAppItemDto, TenantService } from 'projects/ProjetoBaseAngular/domain/services/tenant/tenant.service';
import { WhatsAppConfigService } from '../domain/services/whatsAppConfig.service';
import { WaConnectRequestDto } from 'projects/ProjetoBaseAngular/domain/models/whatsAppApi/models';
import { environment } from 'environments/environment';

interface FacebookLoginResponse {
  authResponse?: {
    code?: string;
  };
  status?: string;
}

interface MetaEmbeddedSignupData {
  code: string;
  wabaId: string;
  phoneNumberId: string;
  registradoWpp: boolean;
  inscritoWebhook: boolean;
}

interface FacebookSdk {
  init(options: {
    appId: string;
    cookie: boolean;
    xfbml: boolean;
    version: string;
  }): void;

  login(
    callback: (response: FacebookLoginResponse) => void,
    options: {
      config_id: string;
      response_type: string;
      override_default_response_type: boolean;
      extras: {
        setup: Record<string, never>;
        featureType: string;
        version: string;
        sessionInfoVersion: string;
      };
    }
  ): void;
}

declare global {
  interface Window {
    FB?: FacebookSdk;
    fbAsyncInit?: () => void;
  }
}

@Component({
  selector: 'app-chatbot-config',
  templateUrl: './chatbot-config.component.html'
})
export class ChatbotConfigComponent extends BaseCrudComponent<ChatBotNodoModel> implements OnInit, OnDestroy {
  @ViewChild('modal') modal: ChatBotNodoModalComponent;

  usuarioWhatsConectado = false;
  usuarioWhatsLogado = false;
  usuarioWhatsJid = "";

  readonly metaAppId = environment.metaEmbeddedSignup.appId;
  readonly metaConfigurationId = environment.metaEmbeddedSignup.configurationId;

  metaSdkCarregado = false;
  metaConectando = false;
  metaStatus = 'Carregando SDK da Meta...';
  metaCode = '';
  metaWabaId = '';
  metaPhoneNumberId = '';
  metaDataConexaoMetaApi: Date;
  metaEmbeddedSignupData: MetaEmbeddedSignupData | null = null;
  metaEmbeddedSignupPorCoexistencia = false;
  metaEnviandoBackend = false;
  metaCredenciaisSalvas = false;
  metaRegistrandoTelefone = false;
  metaInscrevendoApp = false;
  metaConsultandoApps = false;
  metaRemovendoApp = false;
  metaDesregistrandoTelefone = false;
  metaSubscribedAppsConsultado = false;
  metaSubscribedApps: MetaSubscribedAppItemDto[] = [];
  tenant: TenantModel;

  qtdErros: ConfigModel;
  MsgCancCliente: ConfigModel;
  MsgTransfAtendente: ConfigModel;

  selectColumns = [
    { data: 'tipoFluxo' },
    { data: 'mascara' },
    { data: 'nome' },
    { data: 'tipo' },
    { data: 'tipoAtendimento' },
    { data: 'tipoCampo' },
    { data: 'proxNodo' }
  ];

  constructor(
    injector: Injector,
    readonly service: ChatBotNodoService,
    readonly whatsAppConfigService: WhatsAppConfigService,
    readonly whatsChatService: WhatsChatService,
    readonly configService: ConfigService,
    readonly tenantService: TenantService,
    readonly typesService: TypesService,
    private readonly ngZone: NgZone
  ) {
    super(injector, service);
  }

  ngOnInit() {
    super.ngOnInit();
    this.dtOptions.order = [[1, 'asc'], [2, 'asc']];

    window.addEventListener('message', this.metaMessageListener);
    this.loadMetaSdk();

    this.carregarTenantMeta();
    this.initializeForm();
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.metaMessageListener);
  }

  //#region MetaApi

  conectarWhatsAppMeta() {
    if (!this.metaAppId || !this.metaConfigurationId) {
      this.commonService.mensagem(
        'Configuração pendente',
        'Informe o App ID e o Configuration ID da Meta nos arquivos de environment.',
        'warning'
      );
      return;
    }

    if (!this.metaSdkCarregado || !window.FB) {
      this.commonService.mensagem(
        'SDK da Meta indisponível',
        'Aguarde o carregamento e tente novamente.',
        'warning'
      );
      return;
    }

    this.metaConectando = true;
    this.metaStatus = 'Aguardando conclusão do cadastro na Meta...';
    this.metaCode = '';
    this.metaWabaId = '';
    this.metaPhoneNumberId = '';
    this.metaDataConexaoMetaApi = null;
    this.metaEmbeddedSignupData = null;
    this.metaEmbeddedSignupPorCoexistencia = false;
    this.metaCredenciaisSalvas = false;

    window.FB.login(
      (response: FacebookLoginResponse) => {
        console.log('[Meta Embedded Signup] FB.login response:', response);

        this.ngZone.run(() => {
          this.metaConectando = false;

          if (response.authResponse?.code) {
            this.metaCode = response.authResponse.code;
            this.atualizarStatusMeta();
            return;
          }

          if (!this.metaWabaId || !this.metaPhoneNumberId) {
            this.metaStatus = 'Login cancelado ou não autorizado.';
          }
        });
      },
      {
        config_id: this.metaConfigurationId,
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType: 'whatsapp_business_app_onboarding',
          version: 'v4',
          sessionInfoVersion: '3'
        }
      }
    );
  }

  private readonly metaMessageListener = (event: MessageEvent) => {
    if (
      event.origin !== 'https://www.facebook.com' &&
      event.origin !== 'https://web.facebook.com'
    ) {
      return;
    }

    try {
      const data = typeof event.data === 'string'
        ? JSON.parse(event.data)
        : event.data;

      console.log('[Meta Embedded Signup] postMessage raw event:', event);
      console.log('[Meta Embedded Signup] postMessage data:', data);

      if (data?.type !== 'WA_EMBEDDED_SIGNUP') {
        return;
      }

      this.ngZone.run(() => {
        const cadastroConcluido =
          data.event === 'FINISH' ||
          this.isMetaCoexistenciaEvent(data.event);

        if (cadastroConcluido) {
          this.metaWabaId = data.data?.waba_id || '';
          this.metaPhoneNumberId = data.data?.phone_number_id || '';
          this.metaEmbeddedSignupPorCoexistencia = this.isMetaCoexistenciaEvent(data.event);
          this.metaConectando = false;
          this.atualizarStatusMeta();
          return;
        }

        if (data.event === 'CANCEL') {
          const etapa = data.data?.current_step;
          this.metaConectando = false;
          this.metaStatus = etapa
            ? `Cadastro cancelado na etapa: ${etapa}.`
            : 'Cadastro cancelado.';
          return;
        }

        if (data.event === 'ERROR') {
          this.metaConectando = false;
          this.metaStatus = data.data?.error_message
            ? `Erro no cadastro: ${data.data.error_message}`
            : 'Ocorreu um erro durante o cadastro na Meta.';
        }
      });
    } catch {
      // O SDK também envia mensagens que não pertencem ao Embedded Signup.
    }
  };

  private loadMetaSdk() {
    if (window.FB) {
      this.initializeMetaSdk();
      return;
    }

    window.fbAsyncInit = () => this.initializeMetaSdk();

    if (document.getElementById('facebook-jssdk')) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://connect.facebook.net/pt_BR/sdk.js';
    script.onerror = () => {
      this.ngZone.run(() => {
        this.metaStatus = 'Não foi possível carregar o SDK da Meta.';
      });
    };

    document.body.appendChild(script);
  }

  private initializeMetaSdk() {
    if (!window.FB) {
      return;
    }

    window.FB.init({
      appId: this.metaAppId,
      cookie: true,
      xfbml: false,
      version: 'v25.0'
    });

    this.ngZone.run(() => {
      this.metaSdkCarregado = true;
      this.metaStatus = this.tenantTemConfiguracaoMeta()
        ? 'WhatsApp Oficial já conectado.'
        : 'Pronto para conectar.';
    });
  }

  private atualizarStatusMeta() {
    if (this.metaCode && this.metaWabaId) {
      const coexistenciaFlags = this.getMetaCoexistenciaFlags();

      this.metaEmbeddedSignupData = {
        code: this.metaCode,
        wabaId: this.metaWabaId,
        phoneNumberId: this.metaPhoneNumberId,
        registradoWpp: coexistenciaFlags.registradoWpp,
        inscritoWebhook: coexistenciaFlags.inscritoWebhook
      };
      this.metaStatus = this.metaPhoneNumberId
        ? 'Cadastro concluído. Dados prontos para envio ao backend.'
        : 'Cadastro concluído. O backend localizará o número pela conta do WhatsApp.';
      this.enviarMetaCredenciaisBackend(this.metaEmbeddedSignupData);
      return;
    }

    this.metaEmbeddedSignupData = null;
    this.metaStatus = 'Cadastro concluído parcialmente. Aguardando os demais dados da Meta...';
  }

  private async enviarMetaCredenciaisBackend(data: MetaEmbeddedSignupData) {
    if (this.metaEnviandoBackend || this.metaCredenciaisSalvas) {
      return;
    }

    try {
      this.metaEnviandoBackend = true;
      this.metaStatus = 'Enviando dados da Meta ao backend...';
      this.commonService.spinnerOpen('Salvando credenciais da Meta.');

      const tenant = await this.tenantService.getCurrentTenant().toPromise();

      const dto: MetaCredenciaisDto = {
        TenantId: tenant.id,
        Code: data.code,
        WabaId: data.wabaId,
        PhoneNumberId: data.phoneNumberId
      };

      if (data.registradoWpp) {
        dto.RegistradoWpp = true;
      }

      if (data.inscritoWebhook) {
        dto.InscritoWebhook = true;
      }

      await this.tenantService.saveMetaCredenciais(dto).toPromise();

      this.metaCredenciaisSalvas = true;
      await this.carregarTenantMeta();
      this.metaStatus = 'Cadastro concluído. Credenciais da Meta salvas com sucesso.';
      this.commonService.spinnerClose();
      await this.commonService.mensagem('WhatsApp Oficial conectado', 'Credenciais da Meta salvas com sucesso.', 'success');
    } catch (errors) {
      this.commonService.spinnerClose();
      this.metaStatus = 'Cadastro concluído, mas não foi possível salvar as credenciais no backend.';
      this.verifyErrors(errors);
      Swal.fire(
        'Oops! Algo deu errado',
        errors.join('<br>'),
        'error');
    } finally {
      this.metaEnviandoBackend = false;
    }
  }

  private async carregarTenantMeta() {
    this.tenant = await this.tenantService.getCurrentTenant().toPromise();
    this.metaWabaId = this.tenant.metaWabaId || '';
    this.metaPhoneNumberId = this.tenant.metaPhoneNumberId || '';
    this.metaDataConexaoMetaApi = this.tenant.dataConexaoMetaApi;
    this.metaCredenciaisSalvas = this.tenantTemConfiguracaoMeta();

    if (this.metaCredenciaisSalvas) {
      this.metaStatus = 'WhatsApp Oficial já conectado.';
    }
  }

  tenantTemConfiguracaoMeta() {
    return !!(
      this.tenant &&
      this.tenant.metaWabaId &&
      this.tenant.metaPhoneNumberId &&
      this.tenant.metaAccessToken
    );
  }

  //#region Meta API - Coexistencia WhatsApp Business App
  private isMetaCoexistenciaEvent(eventName: string) {
    return eventName === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING';
  }

  private getMetaCoexistenciaFlags() {
    // No fluxo de coexistencia, a Meta ja conclui o onboarding do numero no
    // WhatsApp Business App conectado a Cloud API. Por isso o backend deve
    // persistir o numero como registrado e o webhook como inscrito.
    return {
      registradoWpp: this.metaEmbeddedSignupPorCoexistencia,
      inscritoWebhook: this.metaEmbeddedSignupPorCoexistencia
    };
  }
  //#endregion

  async registrarTelefoneMeta() {
    if (!this.tenantTemConfiguracaoMeta()) {
      await this.commonService.mensagem(
        'Configuração pendente',
        'Conecte o WhatsApp Oficial pela Meta antes de registrar o número.',
        'warning'
      );
      return;
    }

    if (this.tenant.registradoWpp) {
      await this.commonService.mensagem(
        'Número já registrado',
        'Este número já está registrado no WhatsApp Oficial.',
        'info'
      );
      return;
    }

    const result = await Swal.fire({
      title: 'Registrar número na Meta',
      html: 'Informe um PIN de 6 dígitos para vincular ao número do WhatsApp.',
      icon: 'question',
      input: 'password',
      inputAttributes: {
        maxlength: '6',
        inputmode: 'numeric',
        pattern: '[0-9]*'
      },
      showCancelButton: true,
      confirmButtonText: 'Registrar',
      cancelButtonText: 'Cancelar'
    });

    if (!result.isConfirmed) {
      return;
    }

    const pin = String(result.value || '').trim();

    if (!/^[0-9]{6}$/.test(pin)) {
      await this.commonService.mensagem(
        'PIN inválido',
        'O PIN deve possuir exatamente 6 dígitos numéricos.',
        'warning'
      );
      return;
    }

    try {
      this.metaRegistrandoTelefone = true;
      this.commonService.spinnerOpen('Registrando número na Meta.');

      const sucesso = await this.tenantService.registerMetaPhoneNumber({
        TenantId: this.tenant.id,
        Pin: pin
      }).toPromise();

      await this.carregarTenantMeta();
      this.commonService.spinnerClose();

      if (!sucesso) {
        await this.commonService.mensagem(
          'Registro não confirmado',
          'A Meta não confirmou o registro do número.',
          'warning'
        );
        return;
      }

      await this.commonService.mensagem(
        'Número registrado',
        'Número do WhatsApp registrado na Meta com sucesso.',
        'success'
      );
    } catch (errors) {
      this.commonService.spinnerClose();
      this.verifyErrors(errors);
      Swal.fire(
        'Oops! Algo deu errado',
        errors.join('<br>'),
        'error');
    } finally {
      this.metaRegistrandoTelefone = false;
    }
  }

  async subscribeMetaApp() {
    if (!this.tenantTemConfiguracaoMeta()) {
      await this.commonService.mensagem(
        'Configuração pendente',
        'Conecte o WhatsApp Oficial pela Meta antes de inscrever o app.',
        'warning'
      );
      return;
    }

    if (!this.tenant.registradoWpp) {
      await this.commonService.mensagem(
        'Número não registrado',
        'Registre o número do WhatsApp antes de inscrever o app.',
        'warning'
      );
      return;
    }

    try {
      this.metaInscrevendoApp = true;
      this.commonService.spinnerOpen('Inscrevendo app na Meta.');

      const sucesso = await this.tenantService.subscribeMetaApp(this.tenant.id).toPromise();

      this.commonService.spinnerClose();

      if (!sucesso) {
        await this.commonService.mensagem(
          'Inscrição não confirmada',
          'A Meta não confirmou a inscrição do app.',
          'warning'
        );
        return;
      }

      await this.commonService.mensagem(
        'App inscrito',
        'App inscrito na Meta com sucesso.',
        'success'
      );
    } catch (errors) {
      this.commonService.spinnerClose();
      this.verifyErrors(errors);
      Swal.fire(
        'Oops! Algo deu errado',
        errors.join('<br>'),
        'error');
    } finally {
      this.metaInscrevendoApp = false;
    }
  }

  async consultarMetaSubscribedApps() {
    if (!this.tenantTemConfiguracaoMeta()) {
      await this.commonService.mensagem(
        'Configuração pendente',
        'Conecte o WhatsApp Oficial pela Meta antes de consultar os apps inscritos.',
        'warning'
      );
      return;
    }

    try {
      this.metaConsultandoApps = true;
      this.metaSubscribedAppsConsultado = false;
      this.metaSubscribedApps = [];
      this.commonService.spinnerOpen('Consultando apps inscritos na Meta.');

      const resultado = await this.tenantService.getMetaSubscribedApps(this.tenant.id).toPromise();
      this.metaSubscribedApps = resultado && resultado.data ? resultado.data : [];
      this.metaSubscribedAppsConsultado = true;
      this.commonService.spinnerClose();

      if (!this.metaSubscribedApps.length) {
        await this.commonService.mensagem(
          'Nenhum app inscrito',
          'A Meta não retornou apps inscritos para esta conta.',
          'info'
        );
      }
    } catch (errors) {
      this.commonService.spinnerClose();
      this.verifyErrors(errors);
      Swal.fire(
        'Oops! Algo deu errado',
        errors.join('<br>'),
        'error');
    } finally {
      this.metaConsultandoApps = false;
    }
  }

  async removerMetaSubscribedApp() {
    if (!this.tenantTemConfiguracaoMeta()) {
      await this.commonService.mensagem(
        'Configuração pendente',
        'Conecte o WhatsApp Oficial pela Meta antes de remover a inscrição do app.',
        'warning'
      );
      return;
    }

    const result = await Swal.fire({
      title: 'Remover inscrição do app?',
      html: 'Esta ação remove a inscrição do app atual nos webhooks do WABA deste tenant.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar'
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      this.metaRemovendoApp = true;
      this.commonService.spinnerOpen('Removendo inscrição do app na Meta.');

      const sucesso = await this.tenantService.deleteSubscribedApp(this.tenant.id).toPromise();
      this.commonService.spinnerClose();

      if (!sucesso) {
        await this.commonService.mensagem(
          'Remoção não confirmada',
          'A Meta não confirmou a remoção da inscrição do app.',
          'warning'
        );
        return;
      }

      await this.commonService.mensagem(
        'Inscrição removida',
        'Inscrição do app removida na Meta com sucesso.',
        'success'
      );

      await this.consultarMetaSubscribedApps();
    } catch (errors) {
      this.commonService.spinnerClose();
      this.verifyErrors(errors);
      Swal.fire(
        'Oops! Algo deu errado',
        errors.join('<br>'),
        'error');
    } finally {
      this.metaRemovendoApp = false;
    }
  }

  async desregistrarMetaPhoneNumber() {
    if (!this.tenantTemConfiguracaoMeta()) {
      await this.commonService.mensagem(
        'Configuração pendente',
        'Conecte o WhatsApp Oficial pela Meta antes de desregistrar o número.',
        'warning'
      );
      return;
    }

    const result = await Swal.fire({
      title: 'Desregistrar número da Meta?',
      html: 'Esta ação desregistra o número de WhatsApp da Cloud API da Meta. Após a confirmação, o número deixa de funcionar pela API e poderá ser registrado no aplicativo WhatsApp Business do celular. A WABA, os templates e a conta empresarial não serão excluídos.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Desregistrar',
      cancelButtonText: 'Cancelar'
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      this.metaDesregistrandoTelefone = true;
      this.commonService.spinnerOpen('Desregistrando número na Meta.');

      const sucesso = await this.tenantService.deregisterMetaPhoneNumber(this.tenant.id).toPromise();
      this.commonService.spinnerClose();

      if (!sucesso) {
        await this.commonService.mensagem(
          'Desregistro não confirmado',
          'A Meta não confirmou o desregistro do número.',
          'warning'
        );
        return;
      }

      await this.commonService.mensagem(
        'Número desregistrado',
        'Número desregistrado na Meta com sucesso.',
        'success'
      );

      await this.carregarTenantMeta();
    } catch (errors) {
      this.commonService.spinnerClose();
      this.verifyErrors(errors);
      Swal.fire(
        'Oops! Algo deu errado',
        errors.join('<br>'),
        'error');
    } finally {
      this.metaDesregistrandoTelefone = false;
    }
  }

  //#endregion

  async initializeForm() {
    this.qtdErros = await this.configService.getModelByChave(ConfigChatbotConsts.QtdErrosTransfAtend).toPromise();
    this.MsgCancCliente = await this.configService.getModelByChave(ConfigChatbotConsts.MsgCanceladoCliente).toPromise();
    this.MsgTransfAtendente = await this.configService.getModelByChave(ConfigChatbotConsts.MsgTransferidoAtendente).toPromise();

    this.form = this.formBuilder.group({
      qtdErros: [this.qtdErros.valor],
      msgCancCliente: [this.MsgCancCliente.valor],
      msgTransfAtendente: [this.MsgTransfAtendente.valor]
    });
  }

  async saveConfig() {
    this.qtdErros.valor = this.form.value.qtdErros;
    this.MsgCancCliente.valor = this.form.value.msgCancCliente;
    this.MsgTransfAtendente.valor = this.form.value.msgTransfAtendente;

    await this.configService.edit(this.qtdErros).toPromise();
    await this.configService.edit(this.MsgCancCliente).toPromise();
    await this.configService.edit(this.MsgTransfAtendente).toPromise();

    this.commonService.mensagem("Dados salvos com sucesso!", "", "success");
  }  
}
